var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('social-news',{attrs:{"post":_vm.socialNews}})],1),_c('b-col',{attrs:{"md":"4"}},[_c('recent-birthdate'),_c('events')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }